/**
 * @generated SignedSource<<924b9789e8d113261298024025a2a054>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateUserGroupInput = {
  displayName?: string | null | undefined;
  id: string;
  name?: string | null | undefined;
};
export type UpdateUserGroupMutation$variables = {
  input: UpdateUserGroupInput;
};
export type UpdateUserGroupMutation$data = {
  readonly updateUserGroup: {
    readonly userGroup: {
      readonly displayName: string | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly roleAssignmentPrincipal: any;
      readonly uuid: any;
    } | null | undefined;
  };
};
export type UpdateUserGroupMutation = {
  response: UpdateUserGroupMutation$data;
  variables: UpdateUserGroupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateUserGroupPayload",
    "kind": "LinkedField",
    "name": "updateUserGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserGroup",
        "kind": "LinkedField",
        "name": "userGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roleAssignmentPrincipal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uuid",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateUserGroupMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "UpdateUserGroupMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "9f182009b1984e3cf321ee9578b552ec",
    "id": null,
    "metadata": {},
    "name": "UpdateUserGroupMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateUserGroupMutation(\n  $input: UpdateUserGroupInput!\n) {\n  updateUserGroup(input: $input) {\n    userGroup {\n      displayName\n      id\n      name\n      roleAssignmentPrincipal\n      uuid\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e6af5cc1c8151b25b805812d837fd74c";

export default node;
